import sangtao from "../../../assets/images/sangtao.svg";
import khachhang from "../../../assets/images/khachhang.svg";
import benvung from "../../../assets/images/benvung.svg";
import chatluong from "../../../assets/images/chatluong.svg";

export default function Information2() {
  return (
    <div className="w-full container mx-auto p-3 flex flex-col gap-4 md:flex-col mt-7 lg:mt-10 lg:flex-col md:items-center md:justify-between lg:items-center lg:justify-between">
      <div className="flex flex-row gap-1 lg:flex-row lg:items-center lg:gap-2 items-center">
        <p className="text-[28px] text-[#033F6A] font-semibold">
          Giá trị cốt lõi của
        </p>
        <div className="border border-[#27C6FF] w-[7.125rem] h-10 rounded-[40px] bg-[#27C6FF] flex items-center justify-center">
          <p className="text-[1.125rem] font-semibold text-white">BlueSkyIT</p>
        </div>
      </div>
      <div className="grid grid-cols-1 w-full lg:grid-cols-4 gap-3">
        <div className="w-full h-[152px] lg:w-full lg:h-[180px] shadow-custom bg-[#27C6FF] px-[16px] py-[16px] flex md:w-full md:h-[20.25rem] flex-col gap-4 rounded-[20px]">
          <div className="flex flex-row gap-2 items-center">
            <div className="w-12 h-12 bg-white p-2 flex items-center justify-center rounded-full">
              <img src={sangtao} alt="st" />
            </div>
            <div>
              <p className="text-white font-semibold text-[20px]">SÁNG TẠO</p>
            </div>
          </div>

          <div>
            <p className="text-white text-[16px] font-normal">
              Không ngừng đổi mới để mang đến các giải pháp tiên tiến
            </p>
          </div>
        </div>
        <div className="w-full h-[152px] lg:w-full lg:h-[180px] shadow-custom bg-[#3DB72D] px-[16px] py-[16px] flex md:w-full md:h-[20.25rem] flex-col gap-4 rounded-[20px]">
          <div className="flex flex-row gap-2 items-center">
            <div className="w-12 h-12 bg-white p-2 flex items-center justify-center rounded-full">
              <img src={chatluong} alt="st" />
            </div>
            <div>
              <p className="text-white font-semibold text-[20px]">CHẤT LƯỢNG</p>
            </div>
          </div>

          <div>
            <p className="text-white text-[16px] font-normal">
              Cam kết về chất lượng trong từng sản phẩm và dịch vụ.
            </p>
          </div>
        </div>
        <div className="w-full h-[152px] lg:w-full lg:h-[180px] shadow-custom bg-[#4CA8FF] px-[16px] py-[16px] flex md:w-full md:h-[20.25rem] flex-col gap-4 rounded-[20px]">
          <div className="flex flex-row gap-2 items-center">
            <div className="w-12 h-12 bg-white p-2 flex items-center justify-center rounded-full">
              <img src={khachhang} alt="st" />
            </div>
            <div>
              <p className="text-white font-semibold text-[20px]">KHÁCH HÀNG</p>
            </div>
          </div>

          <div>
            <p className="text-white text-[16px] font-normal">
              Tất cả giải pháp của chúng tôi đều xuất phát từ nhu cầu của khách
              hàng
            </p>
          </div>
        </div>
        <div className="w-full h-[152px] lg:w-full lg:h-[180px] shadow-custom bg-[#FF3F4F] px-[16px] py-[16px] flex md:w-full md:h-[20.25rem] flex-col gap-4 rounded-[20px]">
          <div className="flex flex-row gap-2 items-center">
            <div className="w-12 h-12 bg-white p-2 flex items-center justify-center rounded-full">
              <img src={benvung} alt="st" />
            </div>
            <div>
              <p className="text-white font-semibold text-[20px]">BỀN VỮNG</p>
            </div>
          </div>

          <div>
            <p className="text-white text-[16px] font-normal">
              Phát triển dài hạn vì cộng đồng và môi trường.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
